<div class="header-class col-sm-12">
    <!-- <h6>Ligne du bon de commande</h6> -->
</div>
<div *ngIf="form">
    <form [formGroup]="form" id="incremented-line-list" class="col-sm-12">
        <div class="table-container col-sm-12">
            <table #table mat-table [dataSource]="matDataSourceBPLigne" formArrayName="bpLines">
                <caption>Liste des Bps lignes</caption>
                <ng-container matColumnDef="annule">
                    <th mat-header-cell *matHeaderCellDef> A </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        class="align-cell">
                        <mat-icon class="align-icon" *ngIf="element.get('bAnnule').value"
                            style="color: rgb(189, 13, 13);">cancel</mat-icon>
                    </td>
                </ng-container>


                <ng-container matColumnDef="libelle">
                    <th mat-header-cell *matHeaderCellDef> Désignation </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index">
                        {{element.get('libelle').value}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef> N° BC </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index">
                        <div *ngIf="element.get('bcLigne').value">
                            {{element.get('bcLigne').value.bc.code}}
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="position">
                    <th mat-header-cell *matHeaderCellDef> N° Ligne </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index">
                        {{element.get('position').value}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="qteBC">
                    <th mat-header-cell *matHeaderCellDef> Qte BC </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        class="allign-right">
                        <div *ngIf="element.get('bcLigne').value">
                            {{element.get('bcLigne').value.qte | number:'1.3-3' :'fr'}}
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="qteLivre">
                    <th mat-header-cell *matHeaderCellDef> Qte Livre </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        class="allign-right">
                        <div *ngIf="element.get('bcLigne').value">
                            {{element.get('bcLigne').value.qteLivre | number:'1.3-3' :'fr'}}
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="qteRestant">
                    <th mat-header-cell *matHeaderCellDef> Qte Restante </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        class="allign-right">
                        <div *ngIf="element.get('bcLigne').value">
                            {{element.get('bcLigne').value.qteRestant | number:'1.3-3' :'fr'}}
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="qteBP">
                    <th mat-header-cell *matHeaderCellDef> Qte BP </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        class="allign-right">
                        {{element.get('qte').value | number:'1.3-3' :'fr'}}

                    </td>
                </ng-container>

        
                <ng-container matColumnDef="puBC">
                    <th mat-header-cell *matHeaderCellDef> PU BC</th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        class="allign-right">
                        <div *ngIf="element.get('bcLigne').value">
                            {{element.get('bcLigne').value.pu | currency:'EUR':'symbol':'1.2-2':'fr'}}           
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="puBP">
                    <th mat-header-cell *matHeaderCellDef> PU BP</th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        class="allign-right">
                        {{element.get('pu').value | currency:'EUR':'symbol':'1.2-2':'fr'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="htBC">
                    <th mat-header-cell *matHeaderCellDef> HT BC</th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        class="allign-right">
                        <div *ngIf="element.get('bcLigne').value">
                            {{element.get('bcLigne').value.ht | currency:'EUR':'symbol':'1.2-2':'fr'}}
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="htBP">
                    <th mat-header-cell *matHeaderCellDef> HT BP</th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        class="allign-right">
                        {{element.get('ht').value| currency:'EUR':'symbol':'1.2-2':'fr'}}
                    </td>
                </ng-container>
                
                <ng-container matColumnDef="htRestant">
                    <th mat-header-cell *matHeaderCellDef> HT Restant</th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        class="allign-right">
                        <div *ngIf="element.get('bcLigne').value">
                            {{element.get('bcLigne').value.htRestant| currency:'EUR':'symbol':'1.2-2':'fr'}}
                        </div>
                    </td>
                </ng-container>
                
                <ng-container matColumnDef="tva">
                    <th mat-header-cell *matHeaderCellDef> TVA BP</th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index">
                        <app-tva-field-autocomplete codeControlName="codeTva" libelleControlName="libelleTva"
                        tauxControlName="tauxTva" placeholder="TVA" [objets]="detailInfos.tvas" [parentForm]="element">
                        </app-tva-field-autocomplete>
                    </td>
                </ng-container>

                <ng-container matColumnDef="naCode">
                    <th mat-header-cell *matHeaderCellDef> NA </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index">
                        <app-table-field-autocomplete codeControlName="codeNa" libelleControlName="libelleNa"
                            placeholder="NA" [objets]="detailInfos.nas" [parentForm]="element">
                        </app-table-field-autocomplete>
                    </td>
                </ng-container>

                <ng-container matColumnDef="cg">
                    <th mat-header-cell *matHeaderCellDef> CG Charge </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        [matTooltip]="element.get('libelleCgCharge').value">
                        <app-table-field-autocomplete codeControlName="codeCgCharge" libelleControlName="libelleCgCharge"
                             [objets]="detailInfos.cgCharges" [parentForm]="element">
                        </app-table-field-autocomplete>
                    </td>
                </ng-container>

                <ng-container matColumnDef="ca1">
                    <th mat-header-cell *matHeaderCellDef> CA1 </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index">
                        <app-table-field-autocomplete codeControlName="codeCa1" libelleControlName="libelleCa1"
                            placeholder="CA1" [objets]="detailInfos.ca1s" [parentForm]="element">
                        </app-table-field-autocomplete>
                    </td>
                </ng-container>

                <ng-container matColumnDef="ca2">
                    <th mat-header-cell *matHeaderCellDef> CA2 </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index">
                        <app-table-field-autocomplete codeControlName="codeCa2" libelleControlName="libelleCa2"
                            placeholder="CA2" [objets]="detailInfos.ca2s" [parentForm]="element">
                        </app-table-field-autocomplete>
                    </td>
                </ng-container>

                <ng-container matColumnDef="complement">
                    <th mat-header-cell *matHeaderCellDef> Complément </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        [matTooltip]="element.get('libelleComp').value">
                        <app-table-field-autocomplete codeControlName="codeComp" libelleControlName="libelleComp"
                            placeholder="Complement" [objets]="detailInfos.comps" [parentForm]="element">
                        </app-table-field-autocomplete>
                    </td>
                </ng-container>

                <ng-container matColumnDef="equipement">
                    <th mat-header-cell *matHeaderCellDef> Equipement </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index">
                        {{element.get('vehicule').value}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="codeAe">
                    <th mat-header-cell *matHeaderCellDef> Chantier </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index">
                        {{element.get('chantier').value}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="ttc">
                    <th mat-header-cell *matHeaderCellDef> TTC </th>
                    <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                        class="allign-right">
                        {{element.get('ttc').value| currency:'EUR':'symbol':'1.2-2':'fr'}}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsBP ;sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsBP;"
                    [ngClass]="{hovered: row.hovered, highlighted: selection.isSelected(row)}">
                </tr>
            </table>
        </div>
        <mat-toolbar>
                <mat-toolbar-row style="padding: 0px; background-color: white;">
                    <mat-paginator class="paginator" style="width: 100%;" [length]="bpLineFormArray.controls.length" [pageIndex]="0" [pageSize]="10"
                        [pageSizeOptions]="[5, 10, 25, 50]">
                    </mat-paginator>
                </mat-toolbar-row>
        </mat-toolbar>
    </form>
</div>